import { LabourTypeAPI } from '@business/api/labour_type';
import { LabourTypeResponse, LabourTypeId } from '@business/entities/labour-type';
import { CompanyId } from '@business/entities/companies';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class LabourTypeBloc extends BaseBloc {
  private readonly typeRepo = new Repository<LabourTypeResponse>({
    getItemId: item => item.id,
  });

  readonly labourTypes$ = this.typeRepo.items$;
  readonly selectLabourType = this.typeRepo.selectItem;

  onReset() {
    this.typeRepo.reset();
  }

  fetchLabourTypes = (isPublic?: boolean) => {
    return LabourTypeAPI.fetchLabourTypes(isPublic).pipe(this.typeRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_general_error') }));
  };

  fetchLabourType = (id: LabourTypeId) => {
    return LabourTypeAPI.fetchLabourType(id).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_general_error') }),
    );
  };

  createLabourType = (data: Partial<LabourTypeResponse>) => {
    return LabourTypeAPI.createLabourType(data).pipe(
      this.typeRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_labour_type'),
      }),
    );
  };

  updateLabourType = (id: LabourTypeId, data: Partial<LabourTypeResponse>) => {
    return LabourTypeAPI.updateLabourType(id, data).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_labour_type'),
      }),
    );
  };

  deleteLabourType = (id: LabourTypeId) => {
    return showDeleteConfirmation('Delete Categeory', 'Do you really want to remove this labour type?').pipe(
      switchMap(() => LabourTypeAPI.deleteLabourType(id)),
      this.typeRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_labour_type'),
      }),
    );
  };
}
